import { cn } from '@/utils/cn';
import type { CategoryDetail } from '../types/categoriesDetail.types';

interface CategoryInfoBlockProps {
  category: CategoryDetail;
}

export function CategoryInfoBlock({ category }: CategoryInfoBlockProps) {
  return (
    <section className="rounded-md border border-slate-100 bg-white p-3 shadow-sm space-y-4">
      <div className="flex items-center gap-4">
        <div className={cn('flex h-12 w-12 items-center justify-center rounded-md', category?.iconConfig?.tone || 'bg-slate-100 text-slate-600')}>
          <i className={cn(category?.iconConfig?.name || 'ri-folder-line', 'text-2xl')} />
        </div>
        <div className="min-w-0 flex-1">
          <h2 className="truncate text-lg font-medium text-slate-950">{category.name}</h2>
          <p className="text-sm text-slate-500">{category.code}</p>
        </div>
        <div className="shrink-0">
          <span className={cn(
            'rounded-md px-2 py-1 text-xs font-semibold',
            category.status === 'active' ? 'bg-emerald-50 text-emerald-700' : 'bg-slate-100 text-slate-600'
          )}>
            {category.status === 'active' ? 'Hoạt động' : 'Tạm dừng'}
          </span>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="space-y-1">
          <p className="text-xs text-slate-500">Phân loại</p>
          <p className="text-sm font-medium text-slate-900">{category.typeName}</p>
        </div>
        <div className="space-y-1">
          <p className="text-xs text-slate-500">Danh mục cha</p>
          <p className="text-sm font-medium text-slate-900">{category.parentName || 'Không có'}</p>
        </div>
        <div className="space-y-1 md:col-span-2">
          <p className="text-xs text-slate-500">Mô tả</p>
          <p className="text-sm text-slate-700 leading-relaxed">
            {category.description || 'Chưa có mô tả cho danh mục này.'}
          </p>
        </div>
      </div>
    </section>
  );
}
